module.exports = __webpack_public_path__ + "mq.svg?37d2d6810c154684782c747761c2e07c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/mq.svg
// module id = 1254
// module chunks = 0